<div class="benefit-card" [ngClass]="beneficio.statusClass">
  <div class="benefit-card-header" [ngClass]="beneficio.statusClass">
    <h3 class="benefit-title">
      {{beneficio.title}}
    </h3>
    <div *ngIf="beneficio.enabledLabel" class="apply-button">{{beneficio.statusText}}</div>
  </div>
  <div class="benefit-card-content" [ngClass]="beneficio.statusClass">
    <p class="benefit-description" [innerHTML]="convertirUrlsAEnlaces(beneficio.infoBoxMessage)">
    </p>
    <a *ngIf="isStatusClass" (click)="goToBeneficio()" class="detail-link">{{beneficio.requestLinkText}}</a>
  </div>
</div>